import { type Channel } from '@tunarr/types';
import { range } from 'lodash-es';
import { type MarkOptional } from 'ts-essentials';
import type { DropdownOption } from './DropdownOption.ts';

export const OneDayMillis = 1000 * 60 * 60 * 24;
export const OneWeekMillis = OneDayMillis * 7;

// Special ID to use for in-progress entity operations
export const UnsavedId = 'unsaved';

export const DefaultFallbackPicturePath = '/images/generic-offline-screen.png';

// Default channel values that aren't dynamic
export const DefaultChannel: MarkOptional<
  Channel,
  'id' | 'name' | 'number' | 'startTime' | 'transcodeConfigId'
> = {
  duration: 0,
  icon: {
    duration: 0,
    path: '',
    position: 'bottom-right',
    width: 0,
  },
  guideMinimumDuration: 30000,
  fillerRepeatCooldown: 30000,
  groupTitle: 'tunarr',
  stealth: false,
  disableFillerOverlay: false,
  offline: {
    mode: 'pic',
    picture: '',
    soundtrack: '',
  },
  onDemand: {
    enabled: false,
  },
  programCount: 0,
  streamMode: 'hls',
  subtitlesEnabled: false,
  useEtvNext: false,
} as const;

export const TranscodeResolutionOptions = [
  { value: '420x420', description: '420x420 (1:1)' },
  { value: '480x270', description: '480x270 (HD1080/16 16:9)' },
  { value: '576x320', description: '576x320 (18:10)' },
  { value: '640x360', description: '640x360 (nHD 16:9)' },
  { value: '720x480', description: '720x480 (WVGA/EDTV/NTSC 480p NTSC 3:2)' },
  { value: '720x576', description: '720x576 (EDTV/PAL 576p PAL 4:3)' },
  { value: '800x480', description: '800x480 (WVGA 15:9)' },
  { value: '854x480', description: '854x480 (FWVGA 16:9)' },
  { value: '800x600', description: '800x600 (SVGA 4:3)' },
  { value: '1024x768', description: '1024x768 (WXGA 4:3)' },
  { value: '1280x720', description: '1280x720 (HD 16:9)' },
  { value: '1920x1080', description: '1920x1080 (FHD 16:9)' },
  { value: '3840x2160', description: '3840x2160 (4K 16:9)' },
] satisfies DropdownOption<string>[];

export const Plex = 'plex';
export const Jellyfin = 'jellyfin';
export const Emby = 'emby';
export const Imported = 'imported';
export const Local = 'local';

export const AlphanumericCharCodes = [
  '#'.charCodeAt(0),
  ...range('a'.charCodeAt(0), 'z'.charCodeAt(0) + 1),
];
